// extracted by mini-css-extract-plugin
module.exports = {"titlePuls":"titleBarSB_titlePuls__PdP50"};